import React from 'react';
import PropTypes from 'prop-types';
import '../style.scss';

/**
 * ShadowLayer :
 * - ShadowLayer for HexagonCard
 */
export function ShadowLayer(props) {
  return props.shadow ? (
    <>
      <div className='hex_btm_1'></div>
      <div className='hex_btm_2'></div>
      <div className='hex_mid_1'></div>
    </>
  ) : null;
}

ShadowLayer.propTypes = {
  /**
   * Set to show shadow
   */
  shadow: PropTypes.bool,
};

ShadowLayer.defaultProps = {
  shadow: true,
};
